import {EventEmitter, Injectable} from '@angular/core';
import {TreatmentChain} from '../../../model/treatment-chain';
import {StorageService} from '../../storage/storage.service';
import {TranslateService} from '@ngx-translate/core';

/**
 * handle the treatment of treatmentChains, getting them back from server and dispose them
 */
@Injectable()
export class TreatmentChainService {
  public chainsReady: EventEmitter<boolean>;
  /**
   * List of TreatmentChains
   */
  private _TreatmentChainList: TreatmentChain[];

  /**
   * label (and value) for default treatmentChain
   */
  public defaultTreatmentChain;

  /**
   * just instantiate variables
   * @param {StorageService} storageService - handle storage for treatmentChains
   * @param {TranslateService} translate - handle label and value for defaultTreatmentChain
   */
  constructor(private storageService: StorageService, private translate: TranslateService) {
    this._TreatmentChainList = [];
    this.chainsReady = new EventEmitter<boolean>();
    this.init();
  }

  /**
   * build TreatmentChainService for the service and store them
   * @param toBuild - list of Treatment chains gave by the back-office
   */
  public buildTreatmentChains(toBuild: any): void {
    this._TreatmentChainList = [];
    for (const treatmentChain of toBuild) {
      this._TreatmentChainList.push(new TreatmentChain(treatmentChain.sTrtChainName));
    }

    this.storageService.removeTreatmentChainsFromStorage();
    this.storageService.addTreatmentChainsInStorage(this._TreatmentChainList);
    this.chainsReady.emit(true);
  }
  /**
   * getter for TreatmentChainList
   * @return {TreatmentChain[]} - the list of treatment Chain
   */
  getTreatmentChainList(): TreatmentChain[] {
    return this._TreatmentChainList;
  }
  /**
   * handle retrieving info (if they exists) from storage
   */
  init(): void {
    this.translate.get('UPLOAD_COMPONENT.DEFAULT_TREATMENTCHAIN_OPTION').subscribe((label: string) => {
      this.defaultTreatmentChain = label;
    });
    const treatmentChainList = this.storageService.getTreatmentChainsFromStorage();
    if (treatmentChainList) {
      for (const treatmentChain of treatmentChainList) {
        this._TreatmentChainList.push(new TreatmentChain(treatmentChain.sTrtChainName));
      }
    }
  }
}
